import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CustomTableDataSource } from './custom-table-datasource';
import { MatDialog } from '@angular/material/dialog';
import { RequestAttribute } from '../../../../../utils/models/http.interface';
import { DynamicTable } from '../../../../../utils/models/table.interface';
import { HttpService } from '../../../../service/http/http.service';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'custom-table-induxtry',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss']
})
export class CustomTableInduxtryComponent implements OnInit {
    // Define dataSource
    dataSource : any;

    // Define table configuration
    @Input() tableConfig: DynamicTable
    @Input() httpService: any;
    @Input() configApi: any;
    @Input() externalData: any;

    @Output() getNullKeys: EventEmitter<any> = new EventEmitter();
    @Output() getEdit: EventEmitter<any> = new EventEmitter();
    @Output() edit: EventEmitter<any> = new EventEmitter();

    _tableConfig: DynamicTable;
    attributeParams: RequestAttribute[] = [];
    filterParams: RequestAttribute[] = [];


    nullKeys = [];
  requestInitial = [];

  editRow
  data
  key = ''
  elementKey = null;

  currentEditedElement: any;

  constructor(public dialog: MatDialog, public httpServiceRequest: HttpService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this._tableConfig = JSON.parse(JSON.stringify(this.tableConfig));

      this.dataSource = new CustomTableDataSource(this.httpService,  this.configApi, this.dialog, this.externalData);
      this.dataSource.loadRequest(
        this._tableConfig?.endpoint,
        this._tableConfig?.requestParams,
        this.attributeParams,
        this.filterParams
      );

      this.dataSource.data$.subscribe(data => {
        if (data) {
          this.data = data;
          this.checkNullValues(data);
        }
      });

      this.getNullKeys.emit(this.nullKeys)

      this.editRow = new Array(this.data.length).fill(false);

      this.uniqueRequest();
    }

  uniqueRequest() {
    this._tableConfig?.displayedColumns.forEach((res) => {
      if (res?.selectInfinite?.initialGetOptions) {
        res.selectInfinite.initialGetOptions = false;
        this.httpServiceRequest
          .genericGetSelectInfinite<any>(
            res?.selectInfinite?.configApi,
            res?.selectInfinite?.endpoint,
            null,
            {
              sort: '',
              order: '',
              page: 1,
              limit: 30,
            },
            res?.selectInfinite?.attributes
          )
          .subscribe((result) => {
            this.requestInitial = result?.rows;
          });
      }
    });
  }

    checkNullValues(rows: any[]) {
      this.nullKeys = [];

      rows.forEach((element, i) => {
        Object.keys(element).forEach((key, j) => {
          if (element[key] === null) {
            this.nullKeys.push({key:`${i}-${j}`, element: element});
          }
        });
      });
    }

    emptyText(e: any) {
      return e ? e : '-';
    }

    setEdit(index, attribute, element, key) {
      setTimeout(() => {
        if(key === this.key){
          this.elementKey = element['subMercadoRacionamento']
        }
        this.editRow[index] =
        element[attribute] === null || element[attribute] === '';
        const disableButton = !this.editRow.some((e) => e);
        this.edit.emit({ disableButton, attribute, element, key });
        this.getEdit.emit({ disableButton, attribute, element, key });
      }, 100)
    }

  scrollToElement(row: number, col: number): void {
    const key = `${row}-${col}`;
    this.key = key;

    const columnAttribute = this.tableConfig.displayedColumns[col]?.attribute;
    const elementValue = this.data[row]?.[columnAttribute];
    this.elementKey = elementValue

    const element = document.getElementById(key);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }

  showIconError(key: string, number: number): boolean {
    const [value1] = key.split('-');
    let showIcon = false;

    if(key && parseInt(value1) === number && (this.elementKey || this.elementKey === 0)) {
      showIcon = false;
    }
    if(key && parseInt(value1) === number && (this.elementKey === null || this.elementKey === undefined)) {
      showIcon = true;
    }

    return showIcon
  }

}
